<template>
    <ModalWithButton
        name="add-price-group"
        title="Añadir precios al grupo"
        button_title="Añadir precios"
        @cerrar="cerrar"
    >
        <b-row>
            <b-col cols="12" style="min-height: 50vh;">
                <label>Selecciona los precios:</label>
                <multiselect
                    v-model="precios_seleccionados"
                    :options="precios_disponibles"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    label="descripcion"
                    track-by="id"
                    :append-to-body="true"
                />
            </b-col>
            <b-col cols="12">
                <b-button @click="addPrices()">Guardar</b-button>
            </b-col>
        </b-row>
    </ModalWithButton>
</template>

<script>
    import ModalWithButton from '@/components/backend/components/ModalWithButton.vue'

    export default {
        props: {
            grupo_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                precios_disponibles: [],
                loading: false,
                precios_seleccionados: []
            }
        },
        mounted(){
            this.getPreciosDisponibles();
        },
        methods: {
            getPreciosDisponibles() {
                this.loading = true;
                const params = {
                    filters : this.filters,
                    lista_id: this.$store.getters.getListaId
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.grupos.descuentos.disponibles'), params).then(res => {
                    this.precios_disponibles = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            cerrar() {
                this.precios_seleccionados = [];
                this.$modal.hide('add-price-group');
            },
            addPrices() {
                this.loading = true;
                const params = {
                    filters : this.filters,
                    lista_id: this.$store.getters.getListaId,
                    grupo_id: this.grupo_id,
                    precios: this.precios_seleccionados
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.grupos.add.prices'), params).then(res => {
                    this.$emit('actualizar');
                    this.cerrar();
                
                }).finally(() => {
                    this.getPreciosDisponibles();
                    this.precios_seleccionados = [];
                    this.loading = false;
                });
            
            }
        },
        components: {
            ModalWithButton
        }
    }
</script>